import React, { FC } from 'react';
import { Button } from 'antd';
import { useAppSelector } from 'common/hooks/useAppSelector';
import { useAppDispatch } from 'common/hooks/useAppDispatch';
import { history } from 'app/store';
import { Timer } from 'entities/Timer/components/Timer';
import { getEventAvailableOperations } from 'entities/Events/Event.helper';
import { CompleteModal } from 'entities/Modal/components';
import { EEventActionType } from 'entities/Events/Event.enum';
import { IEvent } from 'entities/Events/Event.models';
import { EModalKey } from 'entities/Modal/Modal.enum';

interface IComponentProps {
  event: IEvent | null;
}

export const EventControls: FC<IComponentProps> = ({ event }) => {
  const { auth, eventLoading, timerIsRunning, openCompleteModal } = useAppSelector((state) => ({
    auth: state.auth.data,
    eventLoading: state.event.loading,
    timerIsRunning: state.timer.isRunning,
    physicianList: state.physicianList.data,
    openCompleteModal: state.modal.completeModalParams.open,
  }));
  const { event: eventDispatch, timer: timerDispatch, modal: modalDispatch } = useAppDispatch();

  const currentUserId = auth?.access?.id;
  const role = auth?.access?.rights[0];

  const { canStart, autoStart, canBeMovedToInbox, canBeCompleted } = getEventAvailableOperations({
    status: event?.status,
    role,
    currentUserId,
    staffId: event?.staffId,
    physicianId: event?.physicianId,
  });

  const onMoveToInboxClick = () => {
    eventDispatch.setAction(EEventActionType.MoveToInbox);
    history.back();
  };

  const onCompleteClick = () => {
    modalDispatch.showModal(EModalKey.Complete);
  };

  const onCompleteModalCancelClick = () => {
    modalDispatch.hideModal(EModalKey.Complete);
  };

  const onCompleteModalCompleteClick = (text: string) => {
    if (event) {
      eventDispatch.setAction(EEventActionType.Complete);
      eventDispatch.setText(text);

      if (timerIsRunning) {
        timerDispatch.stopTimer({
          eventId: event.id,
          onSuccess: () => history.back(),
        });
      } else {
        history.back();
      }
    }
  };

  return (
    <div className="p-7 event-controls">
      <div className="mb-5">
        <Timer event={event} canStart={canStart} autoStart={autoStart} />
      </div>

      <div className="mb-5">
        <div className="divider" />
      </div>

      <div className="mb-5">
        <Button className="default" onClick={onMoveToInboxClick} disabled={!canBeMovedToInbox}>
          Move to Inbox
        </Button>
      </div>

      <div className="mb-5">
        <div className="divider" />
      </div>

      <div>
        <Button className="green" onClick={onCompleteClick} disabled={!canBeCompleted}>
          Complete
        </Button>
      </div>

      <CompleteModal
        open={openCompleteModal}
        loading={eventLoading}
        onCompleteClick={onCompleteModalCompleteClick}
        onCancelClick={onCompleteModalCancelClick}
      />
    </div>
  );
};
